<div class="row">
    <div class="col-md-12">
        <div class="row py-3">
            <div class="col-md-12">
                <div class="filters-holder main justify-content-center">
                    <div class="form-group filter-wrap">
                        <ng-select [items]="type17DevicesList" bindLabel="devId" placeholder="Select Grid Meter"
                            class="limit-ng-value" [(ngModel)]="selectedtype17Device"
                            (change)="selectType17Device($event)" notFoundText="No grid meters available">
                        </ng-select>
                    </div>
                    <div class="form-group filter-wrap">
                        <ng-select [items]="type47DevicesList" bindLabel="devId" placeholder="Select Power Sensor"
                            class="limit-ng-value" [(ngModel)]="selectedtype47Device"
                            (change)="selectType47Device($event)" notFoundText="No power sensors available">
                        </ng-select>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Only show filters if at least one device is selected -->
        <div class="filters-holder sm justify-content-end pb-5 px-4" 
             *ngIf="selectedtype17Device || selectedtype47Device">
            <div class="form-group">
                <ng-select [items]="pvTemperature" bindLabel="" placeholder="Temperature" bindValue="" [multiple]="true"
                    [closeOnSelect]="false" class="limit-ng-value" [(ngModel)]="selectedTemperature"
                    (change)="onDropdownSelectionChange()">
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="ng-value">
                            <span class="ng-value-label">{{ items.length }} selected</span>
                        </div>
                    </ng-template>
                </ng-select>
            </div>
            <div class="form-group">
                <ng-select [items]="pvCurrents" bindLabel="" placeholder="Current" bindValue="" [multiple]="true"
                    [closeOnSelect]="false" class="limit-ng-value" [(ngModel)]="selectedCurrents"
                    (change)="onDropdownSelectionChange()">
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="ng-value">
                            <span class="ng-value-label">{{ items.length }} selected</span>
                        </div>
                    </ng-template>
                </ng-select>
            </div>
            <div class="form-group">
                <ng-select [items]="pvFrequency" bindLabel="" placeholder="Frequency" bindValue="" [multiple]="true"
                    [closeOnSelect]="false" class="limit-ng-value" [(ngModel)]="selectedFrequency"
                    (change)="onDropdownSelectionChange()">
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="ng-value">
                            <span class="ng-value-label">{{ items.length }} selected</span>
                        </div>
                    </ng-template>
                </ng-select>
            </div>
            <div class="form-group">
                <ng-select [items]="pvEnergy" bindLabel="" placeholder="Energy" bindValue="" [multiple]="true"
                    [closeOnSelect]="false" class="limit-ng-value" [(ngModel)]="selectedEnergy"
                    (change)="onDropdownSelectionChange()">
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="ng-value">
                            <span class="ng-value-label">{{ items.length }} selected</span>
                        </div>
                    </ng-template>
                </ng-select>
            </div>
            <div class="form-group">
                <ng-select [items]="pvPowers" bindLabel="" placeholder="Power" bindValue="" [multiple]="true"
                    [closeOnSelect]="false" class="limit-ng-value" [(ngModel)]="selectedPowers"
                    (change)="onDropdownSelectionChange()">
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="ng-value">
                            <span class="ng-value-label">{{ items.length }} selected</span>
                        </div>
                    </ng-template>
                </ng-select>
            </div>
            <div class="form-group">
                <ng-select [items]="pvVoltages" bindLabel="" placeholder="Voltage" bindValue="" [multiple]="true"
                    [closeOnSelect]="false" class="limit-ng-value" [(ngModel)]="selectedVoltages"
                    (change)="onDropdownSelectionChange()">
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="ng-value">
                            <span class="ng-value-label">{{ items.length }} selected</span>
                        </div>
                    </ng-template>
                </ng-select>
            </div>
            <div class="form-group">
                <ng-select [items]="pvPercentage" bindLabel="" placeholder="Percentage" bindValue="" [multiple]="true"
                    [closeOnSelect]="false" class="limit-ng-value" [(ngModel)]="selectedPercentage"
                    (change)="onDropdownSelectionChange()">
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="ng-value">
                            <span class="ng-value-label">{{ items.length }} selected</span>
                        </div>
                    </ng-template>
                </ng-select>
            </div>
            <div class="form-group input-group daterange-wrapper">
                <input type="text" class="form-control readonly-g-white" bsDatepicker [bsConfig]="datePickerConfig"
                    #dp="bsDatepicker" placeholder="Date Range" [ngModel]="selectedPVDate" readonly
                    (ngModelChange)="onDateChange($event)" />

                <div class="input-group-append" (click)="dp.toggle()">
                    <span><svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16"
                            fill="none">
                            <path
                                d="M12.8046 1.60066H12.0042V0H10.4036V1.60066H4.00087V0H2.40021V1.60066H1.59987C1.39011 1.60066 1.18241 1.64213 0.988734 1.72268C0.795054 1.80324 0.619218 1.9213 0.471327 2.07006C0.323435 2.21882 0.206406 2.39535 0.126986 2.5895C0.0475649 2.78365 0.00731745 2.99157 0.00854826 3.20133L0.000549316 14.3993C0.000549316 14.8239 0.169189 15.231 0.469373 15.5312C0.769556 15.8314 1.17669 16 1.60121 16H12.7992C13.2237 16 13.6309 15.8314 13.9311 15.5312C14.2312 15.231 14.3999 14.8239 14.3999 14.3993V3.20133C14.3999 2.77773 14.232 2.37141 13.933 2.07138C13.6339 1.77135 13.2282 1.60208 12.8046 1.60066ZM12.8046 14.398H1.60655V5.59433H12.8046V14.398Z"
                                fill="currentColor" />
                        </svg></span>
                </div>
            </div>
        </div>
        
        <div class="pv-chart-container">
            <div class="loaderwrapper" *ngIf="this.loader" style="z-index: 1024;">
                <span class="loader"></span>
            </div>
            <div class="chart-wrapper">
                <!-- Show chart if everything is selected -->
                <div *ngIf="pvMultilineChartOptions && !loader && hasFiltersSelected()" style="width: 100%;">
                    <highcharts-chart #pvMultiChart [Highcharts]="Highcharts" [options]="pvMultilineChartOptions"
                        [update]="updateFlag" [oneToOne]="true">
                    </highcharts-chart>
                </div>

                <!-- Progressive messages -->
                <div *ngIf="!loader && !pvMultilineChartOptions" class="empty-state text-center py-5">
                    <!-- No devices selected -->
                    <div *ngIf="!selectedtype17Device && !selectedtype47Device" class="text-muted">
                        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" 
                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" 
                            style="opacity: 0.3; margin-bottom: 16px;">
                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="9" y1="9" x2="15" y2="15"></line>
                            <line x1="15" y1="9" x2="9" y2="15"></line>
                        </svg>
                        <h5 class="mb-2">No Device Selected</h5>
                        <p class="mb-0">Please select at least one device (Grid Meter or Power Sensor) to load data.</p>
                    </div>

                    <!-- Devices selected but no unit filters -->
                    <div *ngIf="(selectedtype17Device || selectedtype47Device) && !hasFiltersSelected() && pvGraphRes" 
                        class="text-muted">
                        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" 
                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" 
                            style="opacity: 0.3; margin-bottom: 16px;">
                            <line x1="4" y1="21" x2="4" y2="14"></line>
                            <line x1="4" y1="10" x2="4" y2="3"></line>
                            <line x1="12" y1="21" x2="12" y2="12"></line>
                            <line x1="12" y1="8" x2="12" y2="3"></line>
                            <line x1="20" y1="21" x2="20" y2="16"></line>
                            <line x1="20" y1="12" x2="20" y2="3"></line>
                            <line x1="1" y1="14" x2="7" y2="14"></line>
                            <line x1="9" y1="8" x2="15" y2="8"></line>
                            <line x1="17" y1="16" x2="23" y2="16"></line>
                        </svg>
                        <h5 class="mb-2">Select Unit Filters</h5>
                        <p class="mb-0">Data loaded successfully! Now choose unit filters (Voltage, Current, Power, etc.) to display the comparison chart.</p>
                    </div>
                </div>

                <!-- No filters selected but chart exists -->
                <div *ngIf="!hasFiltersSelected() && !loader && pvGraphRes && pvMultilineChartOptions" 
                    class="text-muted text-center py-5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" 
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" 
                        style="opacity: 0.3; margin-bottom: 16px;">
                        <line x1="4" y1="21" x2="4" y2="14"></line>
                        <line x1="4" y1="10" x2="4" y2="3"></line>
                        <line x1="12" y1="21" x2="12" y2="12"></line>
                        <line x1="12" y1="8" x2="12" y2="3"></line>
                        <line x1="20" y1="21" x2="20" y2="16"></line>
                        <line x1="20" y1="12" x2="20" y2="3"></line>
                        <line x1="1" y1="14" x2="7" y2="14"></line>
                        <line x1="9" y1="8" x2="15" y2="8"></line>
                        <line x1="17" y1="16" x2="23" y2="16"></line>
                    </svg>
                    <h5 class="mb-2">Select Unit Filters</h5>
                    <p class="mb-0">Please select at least one unit filter to display the chart.</p>
                </div>
            </div>
        </div>
    </div>
</div>